import axios from "axios";
import { ElLoading, ElMessage } from "element-plus";
import router from "@/router";

var LoadingRequestCount = 0;
var LoadingInstance;

//let apicollection = []
var requestcColl = [];
var closeLoading = false;
let loading;

let request = (config) => {

  const configObj = requestConfig(config)

  const instance = axios.create(configObj);

  instance.interceptors.request.use(
    (config) => {
      // requestcColl.push({
      //   url: config.url,
      //   status: config.status,
      // });

      // if (!closeLoading) {
      //   loading = ElLoading.service({
      //     lock: true,
      //     text: "Loading",
      //     background: "rgba(0, 0, 0, 0.7)",
      //   });
      // }
      showLoading()
      return config;
    },
    (error) => {
      // closeLoading = true;
      // CloseLoading();

      ElMessage({
        message: error,
        type: "danger",
      });

      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      // const requestapi = requestcColl.find(
      //   (t) => t.url === response.config.url && (t?.status || "") === ""
      // );

      // if ((requestapi || null) !== null) {
      //   requestapi.status =
      //     response || (response?.status ?? "nocontent") || "nocontent";
      // }

      // if (loading !== undefined) {
      //   CloseLoading();
      // }

      setTimeout(() => {
        hideLoading();
      }, 200);

      return response;
    },
    (error) => {
      const { response } = error;
      let isError = true;

      // closeLoading = true && (loading || false);
      // CloseLoading();
      setTimeout(() => {
        hideLoading();
      }, 200);

      if (response?.status === 401) {
        if (!response.data.EnableNewLogin) {
          ElMessage({
            message: "Your session has expired or system updated, please login again.",
            type: "error",
          });
        }

        redirectLogin()

        return Promise.reject(error);
      }

      if ((response?.data?.data?.message || "") !== "") {
        isError = false;
        ElMessage({
          message: response.data.data.message,
          type: "warning"
        })
      }

      //console.log("response error", response);

      if (isError) {
        ElMessage({
          message: "系统出现错误",
          type: "error",
        });
        // 对响应错误做点什么
        return Promise.reject(error);
      }

      return response;
    }
  );



  return instance(config);
};

var interval;
const CloseLoading = () => {
  //console.log("CloseLoading");
  interval = setInterval(CloseEvent, 500);
};

const CloseEvent = () => {
  //console.log("CloseEvent", requestcColl);
  if (closeLoading) {
    loading.close();
    loading = undefined;
    requestcColl.splice(0, requestcColl.length);
    clearInterval(interval);
    closeLoading = false;
    //console.log("clearInterval Close Loading", requestcColl, loading);
    return;
  }

  if (
    requestcColl.length > 0 &&
    requestcColl.filter((t) => (t?.status || "") === "").length === 0 &&
    !closeLoading
  ) {
    closeLoading = true;
    //console.log("CloseEvent", requestcColl);
  }
};

const requestConfig = (config) => {

  const xToken = getToken();

  var configs = {
    baseURL: process.env.VUE_APP_API_ADDRESS,
    timeout: 360000,
    headers: {
      Authorization: xToken,
    },
  }

  if (config?.responseType) {
    configs.responseType = config.responseType
  }

  if (config?.contentType) {
    configs.contentType = config.contentType
  }

  if (config?.onUploadProgress) {
    configs.onUploadProgress = config.onUploadProgress
  }

  return configs
}

// 跳转到登陆
const redirectLogin = () => {
  const fullPath = encodeURIComponent(process.env.VUE_APP_DOMAIN + location.pathname + location.search)

  // setTimeout(() => {
  //   console.log("redirectLogin",)
  //   window.location.href = process.env.VUE_APP_DOMAIN + "/login?backurl=" + fullPath
  // }, 500);
  router.push("/login?backurl=" + fullPath)

}



// 显示Loading
const showLoading = () => {
  if (LoadingRequestCount === 0) {
    LoadingInstance = ElLoading.service({
      lock: true,
      text: "Loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
  }

  LoadingRequestCount++;
}

const hideLoading = () => {
  if (LoadingRequestCount <= 0) {
    return;
  }

  LoadingRequestCount--;

  if (LoadingRequestCount === 0) {
    LoadingInstance.close();
  }
}

const getToken = () => {
  return 'Bearer ' + (localStorage.getItem("xToken") || '')
}

export { request, showLoading, hideLoading };
